import { FAQ_SECTION_TITLE, TRUST_FAQ_ITEMS } from '../trustCopy';
import { TrustKeyTerms } from '../trustKeyTerms';

/**
 * Static FAQ: the sanctioned Vanta-pattern addition (TP allowed_cheap_additions):
 * no infra, no hand-maintained dates, native <details> disclosure.
 */
export function TrustFaqSection() {
  return (
    <section className="mt-20 lg:mt-24">
      <h2 className="text-center font-display text-2xl font-semibold text-white md:text-3xl">
        {FAQ_SECTION_TITLE}
      </h2>
      <div className="mx-auto mt-8 max-w-2xl space-y-3">
        {TRUST_FAQ_ITEMS.map((item) => (
          <details key={item.question} className="trust-panel trust-faq group rounded-xl">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 font-display text-sm font-semibold text-gray-100 md:text-base [&::-webkit-details-marker]:hidden">
              <span className="min-w-0 flex-1 text-left">
                <TrustKeyTerms>{item.question}</TrustKeyTerms>
              </span>
              <span
                aria-hidden
                className="shrink-0 text-gray-500 transition-transform duration-200 group-open:rotate-45"
              >
                +
              </span>
            </summary>
            <p className="px-5 pb-5 text-sm leading-relaxed text-gray-300">
              <TrustKeyTerms>{item.answer}</TrustKeyTerms>
            </p>
          </details>
        ))}
      </div>
    </section>
  );
}
